import React from 'react';

const CartPage = () => <div>Cart Page coming soon</div>;

export default CartPage;
